import React from 'react';

import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';

import RefreshIcon from '@mui/icons-material/Refresh';
import CloseIcon from '@mui/icons-material/Close';

import { LinearProgress, IconButton } from '@mui/material';
import Box from '@mui/material/Box';

import { FileUploadProgressResponse } from 'ui/types';

import { StyledLinearProgress } from 'ui/Feed/FileUploadProgress/styles';

import { colors } from 'theme';

import { FileName, FileIconContainer } from '../styles';

interface FileUploadProgressProps {
  fileActivity: FileUploadProgressResponse;
  indeterminate?: boolean;
  error?: boolean;
  onRetry?: () => void;
  onDismiss?: () => void;
}

const FileUploadProgress: React.FC<FileUploadProgressProps> = ({
  fileActivity,
  indeterminate = false,
  error = false,
  onRetry,
  onDismiss,
}) => {
  const progress = (fileActivity.loaded / fileActivity.size) * 100;

  return (
    <Box sx={{ display: 'flex', gap: '8px', margin: '10px 0', padding: '10px 20px' }} key={fileActivity.uuid}>
      <FileIconContainer>
        <AttachFileOutlinedIcon />
      </FileIconContainer>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2px', flex: 1 }}>
        <FileName>{fileActivity.name}</FileName>
        {error && <p style={{ color: colors.error.main, fontSize: '14px', margin: '0' }}>Upload failed</p>}
        {!error && indeterminate && <LinearProgress />}
        {!error && !indeterminate && (
          <StyledLinearProgress value={Math.min(progress, 100)} $success={progress >= 100} />
        )}
      </Box>
      {error && (
        <>
          {onRetry && (
            <IconButton size="small" onClick={onRetry} title="Retry upload">
              <RefreshIcon />
            </IconButton>
          )}
          {onDismiss && (
            <IconButton size="small" onClick={onDismiss} title="Dismiss">
              <CloseIcon />
            </IconButton>
          )}
        </>
      )}
    </Box>
  );
};

export default FileUploadProgress;
